

















































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";

import { getTimeSince } from "@/utils/date-helpers";

/**
 * Components
 */

/**
 * API
 */
import teamsAPI from "@/api/teams";
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";
import DataFetcher from "@/components/_global/DataFetcher.vue";


/**
 * Mixins
 */

/**
 * Types
 */


/**
 * VueX Modules
 */
const profileModule = namespace("profile");
const teamModule = namespace("team");

/**
 * Team's settings page.
 */
@Component({
	components: {DataFetcher}
})
export default class TeamSettingsPage extends Vue {
	/// Injections
	classes = classes;
	externalLinks = externalLinks;
	imageLinks = imageLinks;
	getTimeSince = getTimeSince;

	/// Attributes
	isLoading = false;
	teamInfo: any | null = null;

	/// VueX Modules
	@profileModule.State("userDetails")
	userDetails!: any;

	@teamModule.State("team")
	currentTeam!: GetOneTeamResponse;

	/// Methods
	async created() {
	}

	async fetch() {
		await this.fetchTeamInfos();
	}

	async fetchTeamInfos() {
		this.teamInfo = await teamsAPI.getTeamSettings(this.currentTeam.id);
	}

	async handleUnlinkDiscord() {
		if (window.confirm("Are you sure you want to unlink the discord server?")) {
			this.isLoading = true;
			try {
				await teamsAPI.unlinkDiscord(this.currentTeam.id);
			} catch (error) {
				this.handleAPIError(error);
			}

			await this.fetchTeamInfos();
			this.isLoading = false;
		}
	}
}
